export default __webpack_public_path__ + "static/media/messageReminder48.cced4752.svg";